// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
// require("jquery")

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("jquery")
require("bootstrap-datepicker")
require("jquery.validate.js")
require("Chart.PieceLabel.min.js")
require("select2.min.js")
require("jquery-ui.min.js")
// Bootstrap 4.5.2, the one copy of Bootstrap's JavaScript in this pack. It has
// to come after jquery-ui.min.js, whose tooltip and button widgets would
// otherwise replace Bootstrap's. (The pack also imported the 4.6.2 build
// twice, from bootstrap_custom.js and bootstrap.bundle.js; both were hoisted
// above this line and overwritten by it, so they were dead weight.)
require("bootstrap.min.js")


var Promise = require('promise');

import { polyfill } from 'es6-promise'; polyfill();
// Bootstrap + datepicker styles. A static import, so webpack extracts them to
// css/application-[hash].css and every layout links that from its <head> with
// stylesheet_pack_tag. Until now this was a dynamic import(): the browser had
// to download and run this 2 MB pack before it even learned the stylesheet
// existed, so every page painted without Bootstrap first and then reflowed.
import "../stylesheets/application";
import './bootstrap_custom.js';
import Chart from 'chart.js';
import 'chartjs-plugin-doughnutlabel/dist/chartjs-plugin-doughnutlabel.js';

window.jQuery = $;
window.$ = $;

require("trix")
require("@rails/actiontext")


import * as Sentry from "@sentry/browser";

Sentry.init({
  dsn: "https://ba1f864294b740c08fc4654df370091b@o448105.ingest.sentry.io/5428953",
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,
  environment: "production",
  ignoreErrors: ['Non-Error promise rejection captured'],
  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  integrations: [
    new Sentry.Replay({
      // Additional SDK configuration goes in here, for example:
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
}); 

document.addEventListener("turbo:load", function() {
  Rewardful.Forms.attach();
});